import React from "react";
import Select from "@lwt-helix/select";
import { Label } from "@lwt-helix/controls";
import PropTypes from 'prop-types';

export const FilterSelector = ({
    containerClass='',
    dataLwtId,
    defaultValue,
    labelText,
    options,
    onChange,
    value,
}) => (
    <div className={containerClass}>
        <Label
            dataLwtId={`${dataLwtId}-label`}
            for={dataLwtId}
            className='mb-1 helix-heading'
        >
            {labelText}
        </Label>
        <Select
            id={dataLwtId}
            dataLwtId={dataLwtId}
            className='mt-1 mb-2'
            isClearable={false}
            options={options}
            defaultValue={defaultValue}
            matchFrom='start'
            value={value}
            onChange={(option) => onChange(option)}
        />
    </div>
);

FilterSelector.propTypes = {
    containerClass: PropTypes.string,
    dataLwtId: PropTypes.string.isRequired,
    defaultValue: PropTypes.object,
    labelText: PropTypes.string.isRequired,
    options: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object,
};
